import * as React from 'react';

const DocumentIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    {...props}
  >
    <rect width="58" height="56.4037" rx="28.2018" fill="#E5F1FF" />
    <mask
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="11"
      width="33"
      height="34"
    >
      <rect x="12.4699" y="11.9609" width="32.48" height="32.48" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M19.6532 40.8278C18.9804 40.8278 18.4044 40.5815 17.9253 40.0888C17.4463 39.5962 17.2067 39.0039 17.2067 38.3121V19.6857C17.2067 18.9938 17.4463 18.4016 17.9253 17.9089C18.4044 17.4163 18.9804 17.17 19.6532 17.17H25.6755C25.7606 16.3974 26.0885 15.7404 26.6594 15.1991C27.2301 14.6575 27.9158 14.3867 28.7165 14.3867C29.5172 14.3867 30.203 14.6575 30.7739 15.1991C31.3448 15.7404 31.6683 16.3974 31.7446 17.17H37.7669C38.4397 17.17 39.0157 17.4163 39.4948 17.9089C39.9739 18.4016 40.2134 18.9938 40.2134 19.6857V38.3121C40.2134 39.0039 39.9739 39.5962 39.4948 40.0888C39.0157 40.5815 38.4397 40.8278 37.7669 40.8278H19.6532ZM22.2817 35.4484H31.0784V33.3613H22.2817V35.4484ZM22.2817 30.0426H35.1384V27.9552H22.2817V30.0426ZM22.2817 24.6365H35.1384V22.5494H22.2817V24.6365ZM28.7101 18.3477C29.0033 18.3477 29.2458 18.2491 29.4375 18.0519C29.6292 17.8548 29.7251 17.6055 29.7251 17.3039C29.7251 17.0024 29.6292 16.7531 29.4375 16.5559C29.2458 16.3588 29.0033 16.2602 28.7101 16.2602C28.4168 16.2602 28.1744 16.3588 27.9826 16.5559C27.7909 16.7531 27.6951 17.0024 27.6951 17.3039C27.6951 17.6055 27.7909 17.8548 27.9826 18.0519C28.1744 18.2491 28.4168 18.3477 28.7101 18.3477Z"
        fill="#003594"
      />
    </g>
    {/* <line x1="29.4677" y1="57.0645" x2="29.4677" y2="194.581" stroke="#A4CBFF" strokeWidth="0.935484" /> */}
  </svg>
);

export default DocumentIcon;
